export default "__VITE_ASSET__CSlv0TEZ__"